import { lazy } from 'react';

const RELOAD_FLAG_KEY = 'terrio_chunk_reload';

const isChunkLoadError = (error) => (
  error?.name === 'ChunkLoadError'
  || /Loading (CSS )?chunk [\w-]+ failed/i.test(String(error?.message || ''))
);

const readReloadFlag = () => {
  try {
    return sessionStorage.getItem(RELOAD_FLAG_KEY) === '1';
  } catch {
    return true;
  }
};

const writeReloadFlag = (on) => {
  try {
    if (on) sessionStorage.setItem(RELOAD_FLAG_KEY, '1');
    else sessionStorage.removeItem(RELOAD_FLAG_KEY);
  } catch {
    // sessionStorage puede no estar disponible
  }
};

/**
 * `React.lazy` para vistas con ruta propia. El deploy hace `s3 sync --delete`:
 * una pestaña abierta antes del deploy pide chunks que ya no existen. Ante
 * `ChunkLoadError` recarga la página una sola vez por sesión (trae el
 * `index.html` nuevo); si vuelve a fallar, el error sube al `ErrorBoundary`.
 *
 * @param {() => Promise<{ default: import('react').ComponentType<any> }>} factory
 * @returns {import('react').LazyExoticComponent<import('react').ComponentType<any>>}
 */
export function lazyRoute(factory) {
  return lazy(async () => {
    try {
      const module = await factory();
      writeReloadFlag(false);
      return module;
    } catch (error) {
      if (isChunkLoadError(error) && !readReloadFlag()) {
        writeReloadFlag(true);
        window.location.reload();
        return new Promise(() => {});
      }
      throw error;
    }
  });
}
